import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Destinations from './components/Destinations';
import SouthAmericaBanner from './components/SouthAmericaBanner';
import Gallery from './components/Gallery';
import ToursActivities from './components/ToursActivities';
import FullExperienceBanner from './components/FullExperienceBanner';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <Destinations />
      <Gallery />
      <FullExperienceBanner />
      <ToursActivities />
      <SouthAmericaBanner />
      <Testimonials />
      <Contact />
      <Footer />

      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/56953318253?text=Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20tours"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:bg-[#1ebe5d] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap group"
        aria-label="Contactar por WhatsApp"
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-whatsapp-line text-xl leading-none"></i>
        </div>
        <span className="text-sm font-semibold">¡Escríbenos!</span>
      </a>
    </div>
  );
}
